/* Product-card image carousel — swipe on mobile, arrows + bar indicator on
 * desktop. Cycles a product's images inline on the grid (no page load). */
(function () {
  var galleries = document.querySelectorAll('[data-card-gallery]');
  if (!galleries.length) return;

  galleries.forEach(function (g) {
    var track = g.querySelector('[data-card-track]');
    if (!track) return;
    var count = track.children.length;
    if (count <= 1) return;

    var dots = Array.prototype.slice.call(g.querySelectorAll('[data-card-dot]'));
    var index = 0;
    var suppressClick = false;

    function render() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('bg-white', i === index);
        d.classList.toggle('bg-white/40', i !== index);
      });
    }
    function go(i) { index = (i + count) % count; render(); }

    var prev = g.querySelector('[data-card-prev]');
    var next = g.querySelector('[data-card-next]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(index - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(index + 1); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function (e) { e.preventDefault(); go(i); });
    });

    // Touch swipe
    var startX = 0, startY = 0, delta = 0, dragging = false;
    g.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY; delta = 0; dragging = true;
    }, { passive: true });
    g.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      delta = e.touches[0].clientX - startX;
    }, { passive: true });
    g.addEventListener('touchend', function () {
      dragging = false;
      if (Math.abs(delta) > 40) {
        suppressClick = true;
        setTimeout(function () { suppressClick = false; }, 350);
        if (delta < 0) go(index + 1); else go(index - 1);
      }
    });
    // Stop a swipe from also triggering the image link
    track.addEventListener('click', function (e) {
      if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    render();
  });
})();
